import { render, staticRenderFns } from "./GridInput.vue?vue&type=template&id=060ba511&"
import script from "./GridInput.vue?vue&type=script&lang=ts&"
export * from "./GridInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports